import { Box, Slider, Theme, ThemeProvider } from "@mui/material";
import IconSliderTimer from "assets/icons/isochrone/ic_slider_timer.svg";
import React, { useCallback, useMemo } from "react";
import styles from "../IsochroneDialog.module.scss";
import { useSliderHooks } from "./hooks";
import { SliderCaption } from "./SliderCaption";

const thumbClassName = "minutes-thumb";

export const MinutesSlider = React.memo(
  (props: {
    sliderTheme: Theme;
    id: string;
    value: number;
    formattedMinutes: string;
    onChange: (event: Event, value: number, activeThumb: number) => void;
  }) => {
    const hooks = useSliderHooks({ onChange: props.onChange }, thumbClassName);

    const { sliderRef } = hooks;

    const minutesMin = 1;
    const minutesMax = 30;
    const minutesStep = 1;
    const minutesSteps = Array.from(
      { length: (minutesMax - minutesMin) / minutesStep + 1 },
      (_, i) => i * minutesStep + minutesMin
    );

    const marks = useMemo(
      () =>
        minutesSteps.map((x) =>
          x === minutesMin || x === minutesMax || x % 5 === 0
            ? { value: x, label: `${x} 分` }
            : { value: x, label: "" }
        ),
      [minutesSteps]
    );

    const valueText = useCallback((value: number) => {
      return `${value} 分`;
    }, []);

    const valueLabelFormat = useCallback(
      (value: number) => {
        return valueText(value);
      },
      [valueText]
    );

    return (
      <ThemeProvider theme={props.sliderTheme}>
        <Box className={styles.box}>
          <Box className={styles.ic_tit}>
            <img src={IconSliderTimer} alt="部屋" />
          </Box>
          <Box className={styles.setting}>
            <SliderCaption
              captionRef={hooks.captionRef}
              arrowRef={hooks.arrowRef}
              captionLeft={hooks.captionLeft}
              captionRight={hooks.captionRight}
              arrowLeft={hooks.arrowLeft}
              arrowRight={hooks.arrowRight}
              caption={[String(props.value), "分"]}
              chaseThumb={hooks.chaseThumb}
            />
            <Slider
              ref={sliderRef}
              value={props.value}
              onChange={hooks.onChange}
              valueLabelFormat={valueLabelFormat}
              aria-labelledby={props.id}
              getAriaValueText={valueText}
              valueLabelDisplay="off"
              marks={marks}
              min={minutesMin}
              max={minutesMax}
              step={null}
              slotProps={{
                thumb: {
                  className: thumbClassName
                }
              }}
            />
          </Box>
        </Box>
      </ThemeProvider>
    );
  }
);
